import React from "react";
import "./readTime.scss";
interface IReadTimeProps {
  time: number;
}

const Readtime = (props: IReadTimeProps) => {
  const { time } = props;
  if (!time) return <div style={{marginBottom: '3rem'}}></div>;
  return (
    <div className="flavorcont">
      <span className="flavorcont-text">
        Te tomará unos {time} minutos leer este artículo
      </span>
    </div>
  );
};

export default Readtime;
